import React from "react"
import { useState, useEffect } from 'react';
import { db } from '../services/firebase';
import {withRouter} from 'react-router';

import SubscribePageGridVertica from "./SubscribePageGridVertica"
import GoldPageEditorsNoteSubscribe from "./GoldPageEditorsNoteSubscribe"

function SubscribePage(props){

    const [articles, setArticles] = useState([{location:"this array is not empty"}])

    useEffect(() => {
      const subscriber = db
        .collection('subscribe')
        .where("location", "==", '/subscribe')
        .get()
        .then(snap => {
          const data = snap.docs.map(doc => doc.data())
          setArticles(data)
        });
    }, []);

      if (articles.length !== 0) {
          return (
              <div>
              <GoldPageEditorsNoteSubscribe database={"editorsnote"} />
              <section>
              <hr/>
              </section>
              <section>
              <SubscribePageGridVertica articles={articles} user={props.user}/>
              </section>
              </div>
          )
      } else {
            return (
              <div>
              <p>An Error Has Occured</p>
              </div>
            )}
}

export default withRouter(SubscribePage)
